import { render, staticRenderFns } from "./InicioDocentePage.vue?vue&type=template&id=0447e8ba"
import script from "./InicioDocentePage.js?vue&type=script&lang=js&external"
export * from "./InicioDocentePage.js?vue&type=script&lang=js&external"
import style0 from "./InicioDocentePage.vue?vue&type=style&index=0&id=0447e8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports